import React, { useState, useEffect } from "react";
import "./EditForm.scss";
import { API_URL } from "../../utils/axios";
import axios from "axios";
import PollOptionsEdit from "../PollOptionsEdit/PollOptionsEdit";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";

const options = [
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
];

const EditForm = ({ match }) => {
  const [title, setTitleChange] = useState("");
  const [description, setDescription] = useState("");
  const [location, setLocation] = useState("");
  const [endDateTime, setEndDateTime] = useState(new Date());
  const [pollOption, setPollOption] = useState("");
  const [pollInputChange, setPollInputChange] = useState("");
  const [chooseOptions, setChooseOptions] = useState(null);

  //   useEffect(() => {
  //     axios.get(API_URL + '/yelp').then(response.data).catch(error)
  //   }, [])

  const handleTitleChange = (e) => {
    setTitleChange(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
  };

  const handleEndDateTimeChange = (e) => {
    setEndDateTime(e);
  };

  const handlePollInputChange = (e) => {
    setPollInputChange(e);
    // axios.get(API_URL + '/yelp').then(response => setLocationArray(response.data.businesses)).catch(error)
  };

  const handlePollOptionChange = (e) => {
    // setPollOption(e);
    setPollOption(e);
  };

  const handleChooseOptionChange = (e) => {
    setChooseOptions(e);
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.defaults.headers["foodrtoken"] = localStorage.getItem("token");

    axios
      .get(API_URL + "/poll/get/one/" + match.params.id)
      .then((response) => {
        setTitleChange(response.data.title);
        setDescription(response.data.description);
        setLocation(response.data.location);
        setEndDateTime(new Date(response.data.endDateTime));
        setChooseOptions({ label: response.data.pollOption.length });
        setPollOption(response.data.pollOption);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, [match]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const poll = {
      title: title,
      description: description,
      location: location,
      endDateTime: endDateTime,
      pollOption: pollOption,
    };
    axios.defaults.headers["foodrtoken"] = localStorage.getItem("token");
    axios
      .put(API_URL + "/poll/update/" + match.params.id, {
        ...poll,
      })
      .then((response) => {
        window.location = "/share/" + response.data._id;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <form className="form" onSubmit={handleSubmit}>
      {!loading && (
        <div className="form__container">
          <div className="form__title">
            <label className="form__subheader">Title</label>
            <input
              name="title"
              type="text"
              placeholder="Type your question here..."
              className="form__input"
              onChange={handleTitleChange}
              value={title}
            />
          </div>
          <div className="form__description">
            <label className="form__subheader">Description (optional)</label>
            <textarea
              name="description"
              type="text"
              placeholder="What is this poll for?"
              className="form__input form__input--description"
              rows="3"
              onChange={handleDescriptionChange}
              value={description}
            ></textarea>
          </div>
          <div className="form__location">
            <label className="form__subheader">Location (Required)</label>
            <input
              name="location"
              className="form__input"
              type="text"
              placeholder="Enter your location"
              required="required"
              onChange={handleLocationChange}
              value={location}
            ></input>
          </div>
          <div className="form__time">
            <label className="form__subheader">End date/time</label>
            <div className="date-picker">
              <DatePicker
                selected={endDateTime}
                onChange={handleEndDateTimeChange}
                timeInputLabel="Time:"
                dateFormat="MM/dd/yyyy h:mm aa"
                showTimeInput
                inline
              />
            </div>
          </div>
          <div className="form__answer">
            <label className="form__subheader">Poll Options</label>
            <Select
              value={chooseOptions}
              onChange={handleChooseOptionChange}
              options={options}
            />
          </div>
          <div class="form__poll-options">
            {
              <PollOptionsEdit
                handlePollInputChange={handlePollInputChange}
                number={chooseOptions.label}
                handlePollOptionChange={handlePollOptionChange}
                location={location}
                pollOption={pollOption}
                pollInputChange={pollInputChange}
              />
            }
          </div>
          <div class="form__button-container">
            <button type="submit" className="form__button">
              Update
            </button>
          </div>
        </div>
      )}
    </form>
  );
};
export default withRouter(EditForm);
